import * as CONST from "actions/action_constants";

export const requestProjects = username => ({
  type: CONST.PROJECT_BROWSER_REQUEST,
  username
});

export const kiosksFetchRequest = username => ({
  type: CONST.KIOSKS_FETCH_REQUEST,
  username
});

export const kioskFetchRequest = (kioskID, filters) => ({
  type: CONST.KIOSK_FETCH_REQUEST,
  kioskID,
  filters: filters
});

export const kioskCreateRequest = inputData => ({
  type: CONST.KIOSK_CREATE_REQUEST,
  inputData
});

export const kioskPublishRequest = kioskID => ({
  type: CONST.KIOSK_PUBLISH_REQUEST,
  kioskID
});

export const createKioskRevertCopy = kioskID => ({
  type: CONST.KIOSK_CREATE_REVERT_COPY,
  kioskID
});

export const revertKioskChanges = () => ({
  type: CONST.KIOSK_REVERT_CHANGES
});

// Used to update kiosk settings
export const setKioskProp = (kioskID, prop, value) => ({
  type: CONST.KIOSK_PROP_CHANGE,
  kioskID,
  prop,
  value
});

export const kioskUpdateRequest = (kioskID, saveType) => ({
  type: CONST.KIOSK_UPDATE_REQUEST,
  kioskID,
  saveType
});

export const kioskUpdateHistoryEntry = (kioskID, publishID, stage, status, metadata) => ({
  type: CONST.KIOSK_UPDATE_HISTORY_ENTRY,
  kioskID,
  publishID,
  stage,
  status,
  metadata
});

export const kioskRevertRequest = (kioskID, bundleID) => ({
  type: CONST.KIOSK_REVERT_REQUEST,
  kioskID,
  bundleID
});

export const kioskDeleteRequest = selected => ({
  type: CONST.KIOSK_DELETE_REQUEST,
  selected
});

export const kioskAppVersionsFetchRequest = () => ({
  type: CONST.KIOSK_APP_VERSIONS_FETCH_REQUEST
});
